export const leadingZero = (num: number) => (num <= 9 ? `0${num}` : num);

export const isValidDecimalString = (value: string, scale: number) => {
  const decimals = value.split('.')[1] || '';
  return decimals.length <= scale && (value === '.' || !Number.isNaN(Number(value)));
};
